import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import './index.css';

// 接收登录态和退出登录方法（适配原有逻辑）
const Header = ({ loggedInUser, onLogout }) => {
  const location = useLocation(); // 当前路由（用于高亮导航）
  const navigate = useNavigate(); // 路由跳转

  // 导航菜单（匹配原有路由）
  const navItems = [
    { path: '/', label: '首页' },
    { path: '/archive', label: '归档' },
    { path: '/write', label: '写文章' },
    { path: '/about', label: '我的' },
  ];

  // 未登录时，点击需要权限的导航自动跳登录页
  const handleNavClick = (path) => {
    if (!loggedInUser && ['/write', '/archive', '/about'].includes(path)) {
      navigate('/auth');
      return false;
    }
    return true;
  };

  return (
    <header className="header-wrapper">
      <div className="header-inner">
        {/* Logo/标题 */}
        <div className="header-logo" onClick={() => navigate('/')}>
          我的博客
        </div>

        {/* 导航栏 */}
        <nav className="header-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => handleNavClick(item.path)}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* 右侧用户操作 */}
        <div className="header-user">
          {loggedInUser ? (
            <div className="user-info">
              <span>你好，{loggedInUser.nickname}</span>
              <Button type="text" onClick={onLogout} className="logout-btn">
                退出登录
              </Button>
            </div>
          ) : (
            <Button type="primary" onClick={() => navigate('/auth')}>
              登录/注册
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;